import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Home from '../components/layout/Home/Home'
import Inicio from '../components/layout/Home/Inicio'
import Login from '../components/layout/Login/Login'
import ListadoUsuarios from '../components/layout/Login/ListadoUsuarios'
import Logout from '../components/layout/Login/Logout'
import AuthContextProvider from "./contexts/AuthContext.js";

// {/* Catalogos */}
import BotonesCatalogos from "./views/Catalogos/BotonesCatalogos"
import ListadoAreas from './views/Catalogos/Areas/ListadoAreas'
import ListadoPlanteles from './views/Catalogos/Planteles/ListadoPlanteles'
import ListadoProveedores from './views/Catalogos/Proveedores/ListadoProveedores'
import ProveedoresCreate from './views/Catalogos/Proveedores/ProveedoresCreate'
import ListadoDepartamentos from './views/Catalogos/Departamentos/ListadoDepartamentos'
import ListadoGrupos from './views/Catalogos/Grupos/ListadoGrupos'

// {/* Articulos */}
import Modelos from "./views/Articulos/Modelos";

// {/* Inventarios */}

// Tiendas



// Muestras

// {/* Compras */}

// {/* Ventas */}


// {/* Gastos */}


//Nominas
import BotonesNominas from './views/Empleados/BotonesNominas'
import ListadoNominas from "./views/Empleados/Nominas/ListadoNominas"
import ListadoColaboradores from "./views/Empleados/Colaboradores/ListadoColaboradores"
import ListadoFaltasColaboradores from './views/Empleados/Faltas/ListadoFaltasColaboradores'
import FaltasColaboradoresCreate from './views/Empleados/Faltas/FaltasColaboradoresCreate'
import ListadoPuestos from "./views/Empleados/Puestos/ListadoPuestos"
import NominasCreate from "./views/Empleados/Nominas/NominasCreate"
import ColaboradoresCreate from "./views/Empleados/Colaboradores/ColaboradoresCreate"

// Clientes


//Reportes
// import ListadoSellThruAreaGlobal from "./views/Reportes/ListadoSellThruAreaGlobal";


// Dashboards

// Logs
import Logs from './views/Logs/ListadoLogs'



// Config
import Configuraciones from './views/Configuracion/Configuraciones'

// Admin

// CXP

//Traspasos Dinero


// Whastapp
import Whatsapp from "./views/WhatsApp/Whatsapp";

// Compras

// Traspasos

// Fiscal
import AIChat from "./AI/AIChat";

import BotonesPuntoVenta from "./views/PuntoVenta/BotonesPuntoVenta";
import PosVenta from "./views/PuntoVenta/PosVenta";
import PosCorte from "./views/PuntoVenta/PosCorte";
import PosVentas from "./views/PuntoVenta/PosVentas";
import PosEntradas from "./views/PuntoVenta/PosEntradas";
import PosInventario from "./views/PuntoVenta/PosInventario";
import PosPromociones from "./views/PuntoVenta/PosPromociones";
import PosTiendas from "./views/PuntoVenta/PosTiendas";
import PosReportes from "./views/PuntoVenta/PosReportes";
import PosDevolucion from "./views/PuntoVenta/PosDevolucion";
import PosEtiquetas from "./views/PuntoVenta/PosEtiquetas";
import PosTraspasos from "./views/PuntoVenta/PosTraspasos";
import PosStockBajo from "./views/PuntoVenta/PosStockBajo";
import PosFaltantes from "./views/PuntoVenta/PosFaltantes";
import BotonesReportes from "./views/PuntoVenta/BotonesReportes";
import PosVentasArticulo from "./views/PuntoVenta/PosVentasArticulo";
import PosCaja from "./views/PuntoVenta/PosCaja";

function Routes() {
    return (
        <AuthContextProvider>
            <BrowserRouter forceRefresh={true}>
            <Switch>
                <Route exact path ="/" component={Home} />
                <Route exact path ="/Inicio" component={Inicio} />
                <Route exact path ="/Login" component={Login} />
                <Route exact path ="/Logout" component={Logout} />
                <Route exact path ="/MenuUsuarios" component={ListadoUsuarios} />
                {/* Catalogos */}
                <Route exact path ="/MenuCatalogos" component={BotonesCatalogos} />
                <Route exact path ="/Planteles" component={ListadoPlanteles} />
                <Route exact path ="/Areas" component={ListadoAreas} />
                <Route exact path ="/Departamentos" component={ListadoDepartamentos} />
                <Route exact path ="/Proveedores" component={ListadoProveedores} />
                {/* Articulos */}
                <Route exact path ="/MenuArticulos" component={Modelos} />
                {/* Punto de Venta */}
                <Route exact path ="/PuntoVenta" component={BotonesPuntoVenta} />
                <Route exact path ="/PosVenta" component={PosVenta} />
                <Route exact path ="/PosCorte" component={PosCorte} />
                <Route exact path ="/PosVentas" component={PosVentas} />
                <Route exact path ="/PosEntradas" component={PosEntradas} />
                <Route exact path ="/PosInventario" component={PosInventario} />
                <Route exact path ="/PosPromociones" component={PosPromociones} />
                <Route exact path ="/PosTiendas" component={PosTiendas} />
                <Route exact path ="/PosReportes" component={BotonesReportes} />
                <Route exact path ="/PosReportesVentas" component={PosReportes} />
                <Route exact path ="/PosVentasArticulo" component={PosVentasArticulo} />
                <Route exact path ="/PosDevolucion" component={PosDevolucion} />
                <Route exact path ="/PosEtiquetas" component={PosEtiquetas} />
                <Route exact path ="/PosTraspasos" component={PosTraspasos} />
                <Route exact path ="/PosStockBajo" component={PosStockBajo} />
                <Route exact path ="/PosFaltantes" component={PosFaltantes} />
                <Route exact path ="/PosCaja" component={PosCaja} />
                {/* Gastos */}
                <Route exact path ="/MenuNominas" component={BotonesNominas} />
                <Route exact path ="/Nominas" component={ListadoNominas} />
                <Route exact path ="/Empleados" component={ListadoColaboradores} />
                <Route exact path ="/EmpleadosCreate" component={ColaboradoresCreate} />
                <Route exact path ="/FaltasColaboradores" component={ListadoFaltasColaboradores} />
                <Route exact path ="/FaltasColaboradoresCreate" component={FaltasColaboradoresCreate} />
                <Route exact path ="/NominasCreate" component={NominasCreate} />
                <Route exact path ="/Puestos" component={ListadoPuestos} />
                <Route exact path ="/ProveedoresCreate" component={ProveedoresCreate} />
                {/* Clientes */}
                <Route exact path ="/Grupos" component={ListadoGrupos} />



                {/* Logs  */}
                <Route exact path ="/MenuLogs" component={Logs} />
                {/* Config  */}
                <Route exact path ="/MenuConfiguraciones" component={Configuraciones} />

                
                {/* Whatsapp */}
                <Route exact path ="/Whatsapp" component={Whatsapp} />
            </Switch>
            <AIChat />
            </BrowserRouter>
            </AuthContextProvider>

    )
}

export default Routes
